import styled from 'styled-components';
import PropTypes from 'prop-types';
import DescriptionContainer from './DescriptionContainer';
import SelectionContainer from './SelectionContainer';
import SelectionList from './SelectionList';

const DescriptionSection = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 28px;
  margin-bottom: 38px;
  width: 100%;
`;

const SelectAccountDescription = ({
  options,
  useDescriptionContainer,
  ...props
}) => (
  <DescriptionSection>
    {options.map(({ info, ...desc }) =>
      useDescriptionContainer ? (
        <DescriptionContainer key={desc.title} {...desc} {...props} />
      ) : (
        <SelectionContainer key={desc.title} {...desc} {...props}>
          {!!info && <SelectionList data={info} />}
        </SelectionContainer>
      ),
    )}
  </DescriptionSection>
);

SelectAccountDescription.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      info: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
        }),
      ),
    }),
  ).isRequired,
  useDescriptionContainer: PropTypes.bool,
  onlyTitle: PropTypes.bool,
};

SelectAccountDescription.defaultProps = {
  useDescriptionContainer: false,
  onlyTitle: true,
};

export default SelectAccountDescription;
